import * as vsApi from '../api/vsApi'
import * as digitalIdApi from '../api/digitalIdApi'
import * as settings from '../globals/settings'
import ReactGA from 'react-ga'
import { errorFetching, setErrorState } from '../actions/api'
import { receiveLabResults, setUser, clearData, fetchDeviceType, receiveImmunizationResults } from '../actions/api'
import { mapLabResults } from '../api/mappers/labResultMapper'
import { mapImmunizationResults } from '../api/mappers/immunizationResultMapper'
import { fakeResponse, fakeImmunizationResult } from '../util/fakeData'
import { handleErrors, ERROR_CONTEXT_LOGIN, ERROR_CONTEXT_LOGOUT, ERROR_CONTEXT_REGISTER } from '../util/error_v3'

import ExtendedError from '../util/extendedError'

export const setOpenIdAuthorizationCode = (data) => {
    return {
        type: "SET_OPENID_AUTHORIZATION_CODE",
        data: data,
    }
}

export const setAuthorizationToken = (data) => {
    return {
        type: "SET_AUTHORIZATION_TOKEN",
        data: data,
    }
}

export const setOpenIdVars = (openIdVars) => {
    return {
        type: "SET_OPENID_VARIABLES",
        verifier: openIdVars.verifier,
        nonce: openIdVars.nonce,
        state: openIdVars.state,
        authorizationCode: openIdVars.authorizationCode,
        authorizeUrl: openIdVars.authorizeUrl,
    }
}

export const setLoginState = (data) => {
    return {
        type: "SET_LOGIN_STATE",
        data: data,
    }
}

export const setFakeLoginState = (data) => {
    return {
        type: "SET_FAKE_LOGIN_STATE",
        data: data,
    }
}

export const setLoggingIn = (data) => {
    return {
        type: "SET_LOGGING_IN",
        data: data,
    }
}

export const setLoggingOut = (data) => {
    return {
        type: "SET_LOGGING_OUT",
        data: data,
    }
}

export const setRegistering = (data) => {
    return {
        type: "SET_REGISTERING",
        data: data,
    }
}

export const setPasswordChanging = (data) => {
    return {
        type: "SET_CHANGING_PASSWORD",
        data: data,
    }
}

export const setRequestUsername = (data) => {
    return {
        type: "SET_REQUEST_USERNAME",
        data: data,
    }
}

export const setForgotPassword = (data) => {
    return {
        type: "SET_FORGOT_PASSWORD",
        data: data,
    }
}

export const setResetPassword = (data) => {
    return {
        type: "SET_RESET_PASSWORD",
        data: data,
    }
}

export const setOpenIdAuthorizeUrl = (data) => {
    return {
        type: "SET_OPENID_AUTHORIZE_URL",
        data: data,
    }
}

export const clearAuthData = () => {
    return {
        type: "CLEAR_AUTH_DATA",
    }
}

export const setEmailVerification = (data) => {
    return {
        type: "SET_EMAIL_VERIFICATION",
        data: data,
    }
}
// After catching the redirect, call this!
export const doLogin = (username, password) => {
    return function(dispatch, getState) {
        let fetching = getState().auth.isLoadingLogin;
        // FIXME What device id?
        let deviceId = getState().api.deviceId;
        // Now send this to vs auth api
        if (fetching === false) {
            let language = getState().language.language;
            dispatch(setLoggingIn(true));
            return vsApi.authenticate(username, password, language, deviceId)
                .then(response => {
                    dispatch(setAuthorizationToken(vsApi.getAuthorizationToken(response)));
                    return response.json().then(results => ({ results: results, statusCode: response.status}));
                })
                .then((obj) => {
                    let results = obj.results;
                    let statusCode = obj.statusCode;
                    let error = vsApi.handleLoginErrors(statusCode, results);
                    if (error.error === true) {
                        handleErrors(error, language, ERROR_CONTEXT_LOGIN);
                    }
                    return results;
                })
                .then(results => {
                    dispatch(setLoginState(true));
                    dispatch(setLoggingIn(false));
                    dispatch(fetchDeviceType());
                    return results;
                })
                .catch((err) => {
                    dispatch(setLoggingIn(false));
                    throw new ExtendedError(err.message, err.code, err.errorObj);
                });
        }
    }

}

// After catching the redirect, call this!
export const fakeAuth = () => {
    return function(dispatch, getState) {
        // parse the authorizationCode and store
                    let results = fakeResponse;
                    let immunizations = fakeImmunizationResult;

                    dispatch(setLoginState(true));
                    dispatch(setLoggingIn(false));

                    // Map results
                    if (results.success !== true) {
                        // FIXME HANDLE ERROR.
                        dispatch(setErrorState(true, "Failed to login or fetch lab results", true))
                    } else if(results.data !== null && results.data.patientResults != null) {
                        let { user , sortedResults }  = mapLabResults(results.data.patientResults);
                        // cant destructure due to name collision with sortedResults
                        const imm  = mapImmunizationResults(immunizations.data.patientImmunization);
                        const sortedImmunizationResults = imm.sortedResults

                        console.log("LABS: " + sortedResults);
                        dispatch(receiveLabResults(sortedResults));
                        dispatch(setUser(user));
                        
                        dispatch(receiveImmunizationResults(sortedImmunizationResults))
                        dispatch(fetchDeviceType());
                    }
    }

}

// Need to do 2 things here
// 1. Log out of request-gateway (call vs logout)
// 2. Invalidate authorization token for digital id.
export const doLogoutThunk = () => {
    return function(dispatch, getState) {
        dispatch(setLoggingOut(true));
        let language = getState().language.language;
        // FIXME What device id?
        let deviceId = getState().api.deviceId;
        // FIXME Check if loading
        let authorizationToken = getState().auth.authorizationToken;
        return vsApi.logOut(language, deviceId, authorizationToken)
            .then(response => {
                return response.json().then(results => ({ results: results, statusCode: response.status}));
            })
            .then((obj) => {
                let results = obj.results;
                let statusCode = obj.statusCode;
                let error = vsApi.handleLogoutErrors(statusCode, results);
                if (error.error === true) {
                    handleErrors(error, language, ERROR_CONTEXT_LOGOUT);
                }
                return results;
            })
            .then(result => {
                //digitalIdApi.endSession(authorizationToken)
                //.then(result => {
                        dispatch(clearAuthData());
                        dispatch(clearData());
                //    });
            })
            .catch(err => {
                throw new ExtendedError(err.message, err.code, err.errorObj);
            });
    }
}

export const doRegister = (dto) => {
    return function(dispatch, getState) {
        dispatch(setRegistering(true));
        let language = getState().language.language;
        // FIXME What device id?
        let deviceId = getState().api.deviceId;
        // FIXME Check if loading
        return vsApi.register(dto, language, deviceId)
            .then(response => {
                return response.json().then(results => ({ results: results, statusCode: response.status}));
            })
            .then((obj) => {
                let results = obj.results;
                let statusCode = obj.statusCode;
                let error = vsApi.handleRegisterErrors(statusCode, results);
                if (error.error === true) {
                    handleErrors(error, language, ERROR_CONTEXT_REGISTER);
                }
                return results;
            })
            .then(result => {
                dispatch(setRegistering(false));
                // Do nothing...?
            })
            .catch(err => {
                dispatch(setRegistering(false));
                ReactGA.event({
                    category: 'Registration event',
                    action: 'Registration Failed',
                    label: 'registration-fail'
                  });
                throw new ExtendedError(err.message, err.code, err.errorObj);
            });
    }
}

export const doPasswordChange = (oldPassword, newPassword) => {
    return function(dispatch, getState) {
        let language = getState().language.language;
        // FIXME What device id?
        let deviceId = getState().api.deviceId;
        // FIXME Check if loading
        dispatch(setPasswordChanging(true));
        let authorizationToken = getState().auth.authorizationToken;
        return vsApi.passwordChange(oldPassword, newPassword, language, deviceId, authorizationToken)
            .then(response => {
                return response.json().then(results => ({ results: results, statusCode: response.status}));
            })
            .then((obj) => {
                let results = obj.results;
                let statusCode = obj.statusCode;
                let error = vsApi.handlePasswordChangeErrors(statusCode, results);
                if (error.error === true) {
                    handleErrors(error, language);
                }
                return results;
            })
            .then(result => {
                dispatch(setPasswordChanging(false));
                // Do nothing...?
            })
            .catch(err => {
                dispatch(setPasswordChanging(false));
                throw new ExtendedError(err.message, err.code, err.errorObj);
            });
    }
}

export const doRequestUsernameThunk = (emailAddress) => {
    return function(dispatch, getState) {
        let language = getState().language.language;
        let deviceId = getState().api.deviceId;
        dispatch(setRequestUsername(true));
        dispatch(setRegistering(true));
        return vsApi.requestUsername(emailAddress, language, deviceId)
            .then(response => {
                return response.json().then(results => ({ results: results, statusCode: response.status}));
            })
            .then((obj) => {
                let results = obj.results;
                let statusCode = obj.statusCode;
                let error = vsApi.handleRequestUsernameErrors(statusCode, results);
                if (error.error === true) {
                    handleErrors(error, language);
                }
                return results;
            })
            .then(result => {
                dispatch(setRequestUsername(false));
                dispatch(setRegistering(false));
            })
            .catch(err => {
                dispatch(setRequestUsername(false));
                dispatch(setRegistering(false));
                throw new ExtendedError(err.message, err.code, err.errorObj);
            });
    }
}

export const doForgotPasswordThunk = (username) =>{
    return function(dispatch, getState) {
        dispatch(setForgotPassword(true));
        let language = getState().language.language;
        // FIXME What device id?
        let deviceId = getState().api.deviceId;
        let authorizationToken = getState().auth.authorizationToken;
        // FIXME Check if loading
        return vsApi.forgotPassword(username, language, deviceId, authorizationToken)
            .then(response => {
                return response.json().then(results => ({ results: results, statusCode: response.status}));
            })
            .then((obj) => {
                let results = obj.results;
                let statusCode = obj.statusCode;
                let error = vsApi.handleForgotPasswordErrors(statusCode, results);
                if (error.error === true) {
                    handleErrors(error, language);
                }
                return results;
            })
            .then(result => {
                dispatch(setForgotPassword(false));
                // Do nothing...?
            })
            .catch(err => {
                dispatch(setForgotPassword(false));
                // ReactGA.event({
                //     category: 'Password event',
                //     action: 'Password Failed',
                //     label: 'password-fail'
                // });
                throw new ExtendedError(err.message, err.code, err.errorObj);
            });
    }
}

export const doEmailConfirmationThunk = (token) => {
    return function(dispatch, getState) {
        dispatch(setEmailVerification(true));
        let language = getState().language.language;
        // FIXME What device id?
        let deviceId = getState().api.deviceId;
        // FIXME Check if loading
        return vsApi.doEmailConfirmation(token, language, deviceId)
            .then(response => {
                return response.json().then(results => ({ results: results, statusCode: response.status}));
            })
            .then((obj) => {
                let results = obj.results;
                let statusCode = obj.statusCode;
                let error = vsApi.handleVerifyEmailErrors(statusCode, results);
                if (error.error === true) {
                    handleErrors(error, language, ERROR_CONTEXT_REGISTER);
                }
                return results;
            })
            .then(result => {
                dispatch(setEmailVerification(false));
            })
            .catch(err => {
                dispatch(setEmailVerification(false));
                ReactGA.event({
                    category: 'Registration event',
                    action: 'Registration Failed',
                    label: 'registration-fail'
                });
                throw new ExtendedError(err.message, err.code, err.errorObj);
            });
    }
}

export const doResetPasswordThunk = (newPassword, confirmNewPassword, token) => {
    return function(dispatch, getState) {
        dispatch(setResetPassword(true));
        let language = getState().language.language;
        // FIXME What device id?
        let deviceId = getState().api.deviceId;
        let authorizationToken = getState().auth.authorizationToken;
        // FIXME Check if loading
        return vsApi.resetPassword(newPassword, confirmNewPassword, token, language, deviceId)
            .then(response => {
                return response.json().then(results => ({ results: results, statusCode: response.status}));
            })
            .then((obj) => {
                let results = obj.results;
                let statusCode = obj.statusCode;
                let error = vsApi.handleResetPasswordErrors(statusCode, results);
                if (error.error === true) {
                    handleErrors(error, language);
                }
                return results;
            })
            .then(result => {
                dispatch(setResetPassword(false));
                // Do nothing...?
            })
            .catch(err => {
                dispatch(setResetPassword(false));
                ReactGA.event({
                    category: 'Password event',
                    action: 'Password Failed',
                    label: 'password-fail'
                });
                throw new ExtendedError(err.message, err.code, err.errorObj);
            });
    }
}

// Called when we want to do a soft logout
export const clearEverything = () => {
    return function(dispatch, getState) {
        dispatch(clearAuthData());
        dispatch(clearData());
    }
}
